import * as z from "../../framework";
import { PopUp } from "../../framework/components/components/popUp";
import { settings } from "../../framework/core/settings";
import view from "./uploadPicturePopUp.view";

class UploadPictureArgs {
    success: (e: any) => void;
}

export default class UploadPicturePopUp extends PopUp {

    uploadPictureArgs: UploadPictureArgs;

    constructor(args: UploadPictureArgs) {
        super(view, { screenName: "uploadPicturePopUp" });

        this.popUpArgs = {
            width: 600
        };

        this.uploadPictureArgs = args;
    }
    bindEvents() {
        z.bindLocalizedLanguage({ container: this.get("#UploadPicturePane") });
    }

    initialize() {
        var me = this;
        var container = me.get("#UploadPictureContainer");

        container.append(`<input type='file' name='files' id='${me.zScreen.id}_AttachmentUpload' />`);

        var urlPrefix = settings.appSettings.urlPrefix || "/service/api/";

        me.get("#AttachmentUpload").kendoUpload({
            multiple: false,
            async: {
                saveUrl: `${urlPrefix}Attachment/Upload`,
                autoUpload: false
            },
            select: (e) => {
                var isImage = e.files[0].rawFile.type.split("/")[0] == "image";

                if (!isImage) {
                    z.controls.alert({ header: z.ll("InvalidPictureHeader"), message: z.ll("InvalidPictureMessage"), type: "danger" });
                    e.preventDefault();
                }
            },
            upload: (e) => {
                var xhr = e.XMLHttpRequest;
                if (xhr) {
                    xhr.addEventListener("readystatechange", function () {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader("Authorization-Token", z.getToken());
                            xhr.setRequestHeader("Company-Version", settings.companyVersion);
                        }
                    });
                    e.data = { Description: e.files[0].name };
                }
            },
            complete: () => {
                me.window.close();
            },
            success: me.uploadPictureArgs.success,
            template: "<div class='container full-width-container no-pad'>" +
                "<div class='bold ellipsis col-xs-6 no-pad'>#=name#</div></div>",
            localization: {
                select: z.ll("SelectFile"),
                uploadSelectedFiles: z.ll("UploadFile")
            }
        });
    }

}
